import axios from "axios";
import { ContractList } from "../types/types";
import API from "./API";
import makeHtmltoImage from "./makePDF";

// 가정이사 전체 견적리스트 조회
export const getContractList = async () => {
  const loginUser = JSON.parse(localStorage.getItem("loginUser") || "{}");

  const requestParam = {
    headers: {
      empCod: loginUser.empCod,
    },
  };

  const result = await API.get(`/receipt/list`, requestParam);

  return result;
};

// 가정이사 견적서 이미지 url 리스트 조회

export const getContractImageList = async (reNum: string) => {
  const response = await API.get(`/receipt/contract-image/${reNum}`);
  return response.data;
};

// 가정이사 견적리스트 중에서 statusCode가 "계약미승인" 중에서 날짜가 상담일(consultationDate)이 7일 이상 경과한 견적만 filter
export const filterOverPastContractList = (contractList: any) => {
  const sevenDaysAgo = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setDate(oneMonthAgo.getDate() - 31); // 31일전 날짜
  sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7); // 7일전 날짜 변수 저장

  const result = contractList.filter((contract: any) => {
    if (contract.statusCode !== "21") return false;

    // "20240312" → Date 객체로 변환
    const dateStr = contract.consultationDate;
    const year = parseInt(dateStr.substring(0, 4), 10);
    const month = parseInt(dateStr.substring(4, 6), 10) - 1; // month는 0부터 시작
    const day = parseInt(dateStr.substring(6, 8), 10);

    const consultationDate = new Date(year, month, day);
    return consultationDate <= sevenDaysAgo && consultationDate >= oneMonthAgo;
  });

  return result;
};

// 날짜 변환 함수(YYYY-MM-DD)
export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toISOString().split("T")[0]; // "YYYY-MM-DD" 형식으로 변환
};

// 날짜 변환 함수(20240312 => 2024-03-12(월))
export const formatDateString = (dateStr: string): string => {
  // 날짜 포맷이 8자리(YYYYMMDD)가 아니면 에러 반환
  if (dateStr.length !== 8) return "";

  // 년, 월, 일 분리
  const year = dateStr.slice(0, 4);
  const month = dateStr.slice(4, 6);
  const day = dateStr.slice(6, 8);

  // Date 객체 생성
  const date = new Date(`${year}-${month}-${day}`);

  // 요일 배열
  const daysOfWeek = ["일", "월", "화", "수", "목", "금", "토"];
  const dayOfWeek = daysOfWeek[date.getDay()];

  // 포맷팅된 문자열 반환
  return `${year}-${month}-${day}(${dayOfWeek})`;
};

// 기업이사 견적서 전체 리스트 서비스
export const getCompanyContractList = async () => {
  let contractList = [];
  try {
    const result = await API.get(`/receipt/company-moving/list`);
    const tmpList = result.data.companyMovingList;
    const length = tmpList.length;
    for (let i = 0; i < length; i++) {
      let item = {
        id: tmpList[i].cmCd,
        companyName: tmpList[i].contractInfo.clientInfo.companyName,
        contactPerson: tmpList[i].contractInfo.clientInfo.contactPerson,
        contactNumber: tmpList[i].contractInfo.clientInfo.contactNumber,
        receivedDate: tmpList[i].createdAt.split("T")[0],
        quotation: tmpList[i].chargeList.length + 1,
        status: false,
      };
      contractList.push(item);
    }

    return contractList;
  } catch (error) {
    alert("전체 목록을 가져오는데 실패했습니다.");
    return [];
  }
};

// 기업이사 디테일
export const getCompanyContractDetail = async (cmCd: string) => {
  const result = await API.get(`/receipt/company-moving/${cmCd}`);
  return result.data.companyMovingData;
};

// 기업이사 견적서 수정하기
export const updateCompanyContract = async (requestParam: any) => {
  const result = await API.put(`receipt/company-moving`, requestParam);
  return result;
};

// 기업이사 생성 서비스
export const createCompanyContract = async (requestParam: any) => {
  return await API.post(`/receipt/company-moving`, requestParam);
};

// 기업이사 견적서 이미지 리스트 API
export const getComapanyContractImageList = async (cmCd: string) => {
  try {
    const result = await API.get(`receipt/company-moving/image/${cmCd}`);
    return result.data.companyMovingImages;
  } catch (error) {
    alert("견적서 이미지를 불러오는데 실패했습니다.");
  }
};

// 기업이사 견적서 이미지 변환 함수
export const convertCompanyContractImg = async (
  e: any,
  index: number,
  cmCd: string,
  setCurrentPage: any
) => {
  e.preventDefault();
  // setIsLoading(true);

  let imageList = [];

  for (let i = 1; i <= index; i++) {
    setCurrentPage(i);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    // 페이지 렌더링이 완료된 후 이미지로 변환
    await new Promise<void>((resolve) => {
      requestAnimationFrame(() => resolve());
    });
    const imageFile = await makeHtmltoImage._convertToImg(
      `.companyContractPage${i}`
    );

    imageList.push(imageFile);
  }

  sendCompanyContractImageToServer(imageList, cmCd);
};

export const sendCompanyContractImageToServer = async (
  imageFiles: any,
  cmCd: string
) => {
  const accessToken = localStorage.getItem("accessToken");
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`, // 토큰 넣어주기
      "Content-Type": "multipart/form-data", // 데이터 형식 지정
    },
  };

  // Data URL을 Blob 객체로 변환 및 formData 생성
  const formData = new FormData();
  for (let i = 0; i < imageFiles.length; i++) {
    const blob = await fetch(imageFiles[i]).then((res) => res.blob());
    formData.append("imageData", blob, `${i + 1}.png`);
    formData.append("type", "png");
  }

  const result = await API.post(
    `/receipt/company-moving/image/${cmCd}`,
    formData,
    config
  );
};

// 배관케어(청년배관) 매트리스케어 API

// 배관케어 접수 목록
export const getPlumberCareList = async () => {
  // /v1/api/pipe/receipt/list

  try {
    const result = await API.get(`/pipe/receipt/list`);

    return result;
  } catch (error) {
    alert("배관케어 접수 목록을 가져오는데 실패했습니다.");
    return [];
  }
};

// 매트리스케어 접수 목록
export const getMattressCareList = async () => {
  try {
    const result = await API.get(`/mattress/receipt/list`);

    return result;
  } catch (error) {
    alert("매트리스케어 접수 목록을 가져오는데 실패했습니다.");
    return [];
  }
};

// 배관케어 접수 API
export const submitPlumberReceipt = async (requestParam: any) => {
  const result = await API.post(`/pipe`, requestParam);
  return result;
};

// 매트리스케어 접수 API
export const submitMattressReceipt = async (requestParam: any) => {
  const result = await API.post(`/mattress`, requestParam);
  return result;
};

// 배관케어 디테일 API
export const getPlumberReceiptDetail = async (id: any) => {
  const result = await API.get(`/pipe/receipt/${id}`);

  return result.data.result.pipeReceipt;
};

// 매트리스 디테일 API
export const getMattressReceiptDetail = async (id: any) => {
  const result = await API.get(`/mattress/receipt/${id}`);

  return result.data.result.mattressReceipt;
};

// 배관케어 디테일 업데이트 API
export const updatePlumberReceiptDetail = async (id: any, requestBody: any) => {
  const result = await API.put(`/pipe/${id}`, requestBody);

  return result;
};

// 매트리스 디테일 업데이트 API
export const updateMattressReceiptDetail = async (
  id: any,
  requestBody: any
) => {
  const result = await API.put(`/mattress/${id}`, requestBody);

  console.log(result);
  return result;
};

// 배관케어 견적서 이미지 변환 및 서버 업로드 함수
export const convertPlumberContractImg = async (
  e: React.MouseEvent,
  id: string,
  selector: string
) => {
  e.preventDefault();

  // 렌더링 완료 대기
  await new Promise<void>((resolve) => setTimeout(resolve, 500)); // 0.5초 대기
  await new Promise<void>((resolve) => requestAnimationFrame(() => resolve()));

  const targetElement = document.querySelector(selector);
  if (!targetElement) {
    alert(`'${selector}' DOM 요소가 존재하지 않습니다.`);
    return;
  }

  const imageFile = await makeHtmltoImage._convertToImg(selector);
  await sendPlumberContractImageToServer([imageFile], id); //
};
export const sendPlumberContractImageToServer = async (
  imageFiles: string[],
  id: string
) => {
  const accessToken = localStorage.getItem("accessToken");
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "multipart/form-data",
    },
  };

  const formData = new FormData();

  for (let i = 0; i < imageFiles.length; i++) {
    const blob = await fetch(imageFiles[i]).then((res) => res.blob());
    formData.append("imageData", blob, `${i + 1}.png`);
  }

  formData.append("type", "png");

  try {
    const result = await API.post(
      `/pipe/receipt/image/${id}`,
      formData,
      config
    );
    return result;
  } catch (error) {
    console.error("이미지 전송 실패:", error);
    alert("이미지 전송 실패 (서버 에러 500)");
  }
};

// 매트리스 견적서 이미지 변환 및 서버 업로드 함수
export const convertMattressContractImg = async (
  e: React.MouseEvent,
  id: string,
  selector: string
) => {
  e.preventDefault();

  // 렌더링 완료 대기
  await new Promise<void>((resolve) => setTimeout(resolve, 500)); // 0.5초 대기
  await new Promise<void>((resolve) => requestAnimationFrame(() => resolve()));

  const targetElement = document.querySelector(selector);
  if (!targetElement) {
    alert(`'${selector}' DOM 요소가 존재하지 않습니다.`);
    return;
  }

  const imageFile = await makeHtmltoImage._convertToImg(selector);
  await sendMattressContractImageToServer([imageFile], id); //
};
export const sendMattressContractImageToServer = async (
  imageFiles: string[],
  id: string
) => {
  const accessToken = localStorage.getItem("accessToken");
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "multipart/form-data",
    },
  };

  const formData = new FormData();

  for (let i = 0; i < imageFiles.length; i++) {
    const blob = await fetch(imageFiles[i]).then((res) => res.blob());
    formData.append("imageData", blob, `${i + 1}.png`);
  }

  formData.append("type", "png");

  try {
    const result = await API.post(
      `/mattress/receipt/image/${id}`,
      formData,
      config
    );
    return result;
  } catch (error) {
    console.error("이미지 전송 실패:", error);
    alert("이미지 전송 실패 (서버 에러 500)");
  }
};
